(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["medshrum-absorption"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-absorption-section]').forEach((section) => {
    const tabs = [...section.querySelectorAll('[data-absorption-tab]')];
    const panels = [...section.querySelectorAll('[data-absorption-panel]')];
    const activateTab = (tab) => {
      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
        activateTab(nextTab);
        nextTab.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
